module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak pieszy czerwony.svg?a032558e";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak pieszy czerwony.svg
// module id = 2122
// module chunks = 0